import React, { useCallback, useEffect, useMemo, useState } from 'react';
import { StyledReports, StyledReportsContent } from './styled';
import AppBar from '../../../../components/AppBar';
import TabsLinks from '../../../../components/TabsLinks';
import { paths } from '../../../../routes';
import Layout from '../../../../components/Layout';
import Button from '../../../../components/Button';
import Icon from '../../../../components/Icon';
import PlaceSelect from '../../components/PlaceSelect';
import ReportsTable from './components/ReportsTable';
import { useSelector } from 'react-redux';
import Loader from '../../../../components/Loader';
import { useManage } from '../../../../hooks/useManage';
import { useApi } from '../../../../hooks/useApi';
import { ApiReports } from '../../../../api/reports';
import { OPERATIONS } from '../../../../utils/constans';
import { filterDataByString, parseReports } from '../../../../utils/helpers';
import { toast } from 'react-toastify';
import Modal from '../../../../components/Modal';
import FormGenerateRaport from '../../../../forms/FormGenerateRaport';
import FormConfirmDelete from '../../../../forms/FormConfirmDelete';
import { Col, Row } from 'react-styled-flexboxgrid';
import Search from '../../../../components/Search';
import { useTranslation } from 'react-i18next';

const Reports = () => {
    const { t } = useTranslation()
    const role = useSelector(state => state.auth.user?.user?.role?.type);
    const placesLoading = useSelector(state => state.places.loading);
    const placeSelected = useSelector(state => state.places.selected);
    const placesData = useSelector(state => state.places.data);
    const [{ operation, id: activeID }, setState] = useManage();

    const [searchShow, setSearchShow] = useState(false);
    const [searchText, setSearchText] = useState("");

    // Setup request
    const [{ data: reportsData, loading: reportsLoading }, getReports] = useApi(ApiReports.get, { manual: true });
    const [{ loading: reportsCreateLoading }, create] = useApi(ApiReports.create, { manual: true });
    const [{ loading: reportsDeleteLoading }, deleteReport] = useApi(ApiReports.delete, { manual: true });

    // Click handlers
    const handleClickAdd = () => setState(OPERATIONS.ADD, null);
    const handleClickDelete = id => () => setState(OPERATIONS.DELETE, id);
    const handleClickCancelModal = () => setState(OPERATIONS.READ, null);

    const getReportsByPlace = useCallback(
        () => {
            if (placeSelected?.id) {
                const placeId = placeSelected.id === 'all' ? null : placeSelected.id;
                getReports({ place: placeId });
            }
        },
        [placeSelected, getReports],
    );

    useEffect(() => {
        getReportsByPlace();
    }, [getReportsByPlace]);

    const reports = useMemo(
        () => reportsData && parseReports(reportsData),
        [reportsData]
    );

    const reportsFiltered = useMemo(
        () => {
            return filterDataByString(reports, searchText, report => report?.name);
        },
        [reports, searchText]
    );

    const handleChangeSearch = e => setSearchText(e.target.value);

    const handleClickSearchIcon = () => setSearchShow(prevState => !prevState);

    const handleSubmit = async (data) => {
        //CREATE
        const res = await create(data);

        if (res?.data) {
            setState(OPERATIONS.READ, null);
            getReportsByPlace();
        }
    };

    const handleSubmitDelete = async () => {
        //DELETE
        const res = await deleteReport(activeID);
        if (res?.data) {
            toast.success(t('Raport został usunięty'));
            setState(OPERATIONS.READ, null);
            getReportsByPlace();
        }
    };

    return (
        <StyledReports>
            <AppBar>
                <PlaceSelect />
            </AppBar>
            <TabsLinks
                tabs={[{
                    to: paths.reports,
                    name: t('Raporty')
                }]}
                rightContent={
                    <Row middle="xs">
                        <Col>
                            <Search
                                value={searchText}
                                onChange={handleChangeSearch}
                                expanded={searchShow}
                                onClickSearchIcon={handleClickSearchIcon}
                            />
                        </Col>
                        <Col>
                            <Button
                                startIcon={
                                    <Icon
                                        name="add"
                                        width={12}
                                        height={12}
                                    />
                                }
                                onClick={handleClickAdd}
                            >
                                {t("Nowy raport")}
                            </Button>
                        </Col>
                    </Row>
                }
            />
            <Layout>
                <StyledReportsContent>
                    <ReportsTable
                        reports={reportsFiltered}
                        onClickDelete={handleClickDelete}
                    />
                </StyledReportsContent>
            </Layout>
            <Modal
                open={operation === OPERATIONS.ADD}
            >
                <FormGenerateRaport
                    initialValues={placeSelected?.id !== 'all' ? { place_id: placeSelected?.id } : {}}
                    role={role}
                    loading={reportsLoading}
                    places={placesData}
                    onSubmit={handleSubmit}
                    onClickCancel={handleClickCancelModal}
                />
            </Modal>
            <Modal
                open={operation === OPERATIONS.DELETE}
            >
                <FormConfirmDelete
                    loading={reportsDeleteLoading}
                    onSubmit={handleSubmitDelete}
                    onClickCancel={handleClickCancelModal}
                />
            </Modal>
            <Loader show={placesLoading || reportsLoading || reportsCreateLoading} />
        </StyledReports >
    )
}

export default Reports;
